<template>
  <div id="page" class="subpage">
    <tk-ask-us-dialog v-model="showAskUsDialog" topic="commission" />

    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>
    <div v-else class="page-container">
      <h1>{{ data.title }}</h1>
      <tk-froala :content="data.content" class="mt-4" />
      <div class="text-xs-center mt-5">
        <tk-btn
          block
          class="commision-btn"
          v-if="pageSlug === 'commission' "
          color="primary"
          large
          @click="showAskUsDialog = true"
        >
          <span>{{ $t('COMMON.ORDER_COMMISION') }}</span>
        </tk-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
const handler = new ErrorHandler();

export default {
  components: {
    TkFroala: () => import("@/components/core/TkFroala"),
    TkAskUsDialog: () => import("@/components/core/TkAskUsDialog")
  },

  created() {
    this.fetchData();
  },

  data() {
    return {
      loading: true,
      pageSlug: null,
      showAskUsDialog: false,
      data: {}
    };
  },

  watch: {
    $route: "fetchData"
  },

  methods: {
    async fetchData() {
      this.data = {};
      this.pageSlug = this.$route.path.replace("/", "");
      console.log("FetchData with slug", this.pageSlug);

      this.loading = true;
      await handler.handle(async () => {
        const res = await this.$axios.get(`pages/${this.pageSlug}`);
        this.data = res.data["data"];

        this.$app.setTitle(this.data.title);
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.subpage {
  max-width: 800px;
}
.commision-btn {
  font-size: 1.8rem;
  height: 60px;
}
</style>
